module.exports = __webpack_public_path__ + "static/media/back.8da188ac.jpg";